import { apiFetch } from './client';
import type { DirectoryUser } from './types';

/** Shortest term the API will act on; below this it answers an empty list without querying Graph. */
export const MIN_USER_SEARCH_LENGTH = 2;

/**
 * Searches Microsoft Entra ID users. Restricted to group admins by the API, and cancellable so a stale
 * keystroke never overwrites a fresher result.
 */
export function searchDirectoryUsers(
  search: string,
  take = 10,
  signal?: AbortSignal,
): Promise<DirectoryUser[]> {
  const query = new URLSearchParams({ search, take: String(take) });
  return apiFetch<DirectoryUser[]>(`/api/directory/users?${query.toString()}`, { signal });
}
